import script from "./ActionsMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./ActionsMenu.vue?vue&type=script&setup=true&lang=js"

import "./ActionsMenu.vue?vue&type=style&index=0&id=fa61771a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa61771a"]])

export default __exports__